export enum FormStatus {
	PENDING = 'PENDING',
	ACTIVE = 'ACTIVE',
	SUBMITTED = 'SUBMITTED',
	TO_REVIEW = 'TO_REVIEW',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
	CANCELLED = 'CANCELLED',
	ASSIGNED = 'ASSIGNED'
}
